import * as React from 'react';
import {
  Edit,
  SimpleForm,
} from 'react-admin';
import ClassicalContentForm from './ClassicalContentForm';
import FormToolbar from '../shared/FormToolbar';

const ClassicalContentEdit = props => (
  <Edit {...props} undoable={false}>
    <SimpleForm toolbar={<FormToolbar />}>
      <ClassicalContentForm {...props} />
    </SimpleForm>
  </Edit>
);

export default ClassicalContentEdit;
